import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { SocialContext } from '../contexts/socialContext';
import { StateContext } from '../contexts/stateContext';
import { GROUP_TOKEN_LENGTH } from './utilsDesign';
import { PreloaderHD } from './UiKit/PreloaderHD';
import {
  _getGroup,
  _getGroupAdmins,
  _getGroupMembers,
  _getMyRequests,
  _requestToJoin,
  _seeGroupInvitations
} from './utilsGroup';

export function WithGroup({ id, children }) {
  const context = { ...useContext(SocialContext), ...useContext(StateContext) };
  const { groupId } = useParams();
  const groupToken = id || groupId;
  const tokenReady = Boolean(groupToken && groupToken.length === GROUP_TOKEN_LENGTH);
  const meToken = context.me?.user?.token;

  const [group, setGroup] = useState();
  const [invited, setInvited] = useState([]);
  const [admins, setAdmins] = useState();
  const [members, setMembers] = useState();
  const [myRequests, setMyRequests] = useState([]);

  const updateGroup = (newData) => {
    context.x.updateGroup({ ...newData }, (data) => {
      setGroup(data)
    })
  }

  const fetchGroup = async () => {
    try {
      const data = await _getGroup(groupToken);
      const invitation = Boolean(
        context.groups?.find(one => one.token === groupToken)?.invitation
      );
      setGroup({ ...data, invitation });
    } catch (error) {
      console.log('error = ', error);
    }
  };

  const fetchMembers = async () => {
    try {
      const data = await _getGroupMembers(groupToken);
      setMembers(data);
    } catch (error) {
      console.log('error = ', error);
    }
  };

  const fetchMyRequests = async () => {
    try {
      const data = await _getMyRequests();
      setMyRequests(data || []);
    } catch (error) {
      console.log('error = ', error);
    }
  };

  const fetchAdmins = async () => {
    try {
      const data = await _getGroupAdmins(groupToken);
      setAdmins(data);
    } catch (error) {
      console.log('error = ', error);
    }
  };

  const fetchInvited = () => {
    if (!groupToken) return;
    _seeGroupInvitations(groupToken, (data) => setInvited(data || []));
  };

  useEffect(() => {
    if (!tokenReady) return;
    setGroup();
    setMembers();
    setAdmins();
    setInvited([]);
    setMyRequests([]);
    fetchGroup();
    fetchMembers();
    fetchAdmins();
  }, [groupToken, tokenReady]);

  const invitation = Boolean(
    context.groups?.find(one => one.token === groupToken)?.invitation
  );
  const groupWithInvitation = useMemo(() => {
    if (!group) return group;
    if (Boolean(group.invitation) === invitation) return group;
    return { ...group, invitation };
  }, [group, invitation]);

  useEffect(() => {
    if (!tokenReady || !meToken) return;
    fetchMyRequests();
  }, [groupToken, tokenReady, meToken]);

  useEffect(() => {
    if (!tokenReady || !meToken || !admins) return;
    const isAdmin = admins.some((user) => user?.user?.token === meToken);
    if (!isAdmin) return;
    fetchInvited();
  }, [admins, meToken, groupToken, tokenReady]);

  const requestToJoin = () => {
    if (!group?.token) return;
    _requestToJoin(group.token, () => {
      fetchMyRequests()
      context.x.getGroups?.()
    })
  }

  const parameters = {
    group: groupWithInvitation,
    members,
    admins,
    invited,
    myRequests,
    updateGroup,
    requestToJoin,
    fetchMembers,
    fetchMyRequests,
    fetchInvited,
    fetchGroup,
  };

  const ready = Boolean(
    tokenReady
    && group
    && members
    && admins
    && meToken
  );

  return (
    <>
      {!ready && <PreloaderHD />}
      {ready
        ? React.Children.map(children, child =>
          React.cloneElement(child, parameters)
        )
        : null}
    </>
  );
}
